export const NUM_MAX_RESERVATION_SLOTS = 10;
export const NUM_MIN_RESERVATION_SLOTS = 0;
export const NUM_MAX_NEW_RESERVATION_SLOTS = 10;
export const NUM_MIN_NEW_RESERVATION_SLOTS = 0;
export const TEXT_CHECK_IS_NEW_RESERVATION = '新規';
export interface ReservationAcceptanceDeadline {
    value: string,
    name: string,
  }
export const RESERVATION_ACCEPTANCE_DEADLINE: ReservationAcceptanceDeadline[] = [
  { value: 'JUST_BEFORE', name: '直前まで予約可能' },
  { value: 'BEFORE_THREE_HOURS', name: '当日の3時間前まで予約可能' },
  { value: 'NEXT_DAY', name: '翌日以降の予約可能' },
  { value: 'TWO_DAYS_AFTER', name: '翌々日以降の予約可能' },
];

export const INQUIRY_ACCEPTANCE_DEADLINE: ReservationAcceptanceDeadline[] = [
  { value: 'JUST_BEFORE', name: '直前まで受付可能' },
  { value: 'BEFORE_THREE_HOURS', name: '当日の3時間前まで受付可能' },
  { value: 'NEXT_DAY', name: '翌日以降の受付可能' },
  { value: 'TWO_DAYS_AFTER', name: '翌々日以降の受付可能' },
];

export const DEFAULT_INQUIRY_ACCEPTANCE_DEADLINE = 'BEFORE_THREE_HOURS';

export const DEFAULT_BOOKING_GAP_MINUTES = 30;

/**
 * 予約可能期間（当日基準・C3_CI_ZLABO-2912）
 * 未設定（null）の場合は BE と同じく UNLIMITED 扱いとする
 */
export const POSSIBLE_MONTH_CODE = {
  ONE_MONTH_AHEAD: '0',
  TWO_MONTHS_AHEAD: '1',
  UNLIMITED: '2',
};
export const DEFAULT_POSSIBLE_MONTH_CODE = POSSIBLE_MONTH_CODE.UNLIMITED;
export const POSSIBLE_MONTH_CODE_OPTIONS = [
  { value: POSSIBLE_MONTH_CODE.ONE_MONTH_AHEAD, text: '1か月先まで' },
  { value: POSSIBLE_MONTH_CODE.TWO_MONTHS_AHEAD, text: '2か月先まで' },
  { value: POSSIBLE_MONTH_CODE.UNLIMITED, text: '制限なし' },
];

export const INQUIRY_ACCEPT_PERIOD_MONTH_CODE = {
  ONE_MONTH_AHEAD: '0',
  TWO_MONTHS_AHEAD: '1',
  THREE_MONTHS_AHEAD: '2',
  UNLIMITED: '3',
};
export const DEFAULT_INQUIRY_ACCEPT_PERIOD_MONTH_CODE = INQUIRY_ACCEPT_PERIOD_MONTH_CODE.UNLIMITED;
export const INQUIRY_ACCEPT_PERIOD_MONTH_CODE_OPTIONS = [
  { value: INQUIRY_ACCEPT_PERIOD_MONTH_CODE.ONE_MONTH_AHEAD, text: '1か月先まで' },
  { value: INQUIRY_ACCEPT_PERIOD_MONTH_CODE.TWO_MONTHS_AHEAD, text: '2か月先まで' },
  { value: INQUIRY_ACCEPT_PERIOD_MONTH_CODE.THREE_MONTHS_AHEAD, text: '3か月先まで' },
  { value: INQUIRY_ACCEPT_PERIOD_MONTH_CODE.UNLIMITED, text: '制限なし' },
];

export const getInquiryAcceptPeriodMonths = (code?: string | null): number | null => {
  switch (code) {
    case INQUIRY_ACCEPT_PERIOD_MONTH_CODE.ONE_MONTH_AHEAD:
      return 1;
    case INQUIRY_ACCEPT_PERIOD_MONTH_CODE.TWO_MONTHS_AHEAD:
      return 2;
    case INQUIRY_ACCEPT_PERIOD_MONTH_CODE.THREE_MONTHS_AHEAD:
      return 3;
    default:
      return null;
  }
};
